import { CompRef } from '@wix/document-services-types';
import {
  ComponentsService,
  ManifestContextAPI,
} from '@wix/editor-platform-manifest-services';
import { EditorPointer } from '@wix/editorx-core-api';
import { ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME } from '../../constants';
import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { GlobalDesignActionValidator } from '../../types';
import { Style } from '@wix/component-protocol/schema';

const createDefaultStyleActionValidator =
  (actionName: StylesDerivedNativeActionNames): GlobalDesignActionValidator =>
  (componentsAPI: ComponentsService, editorPointer: EditorPointer<CompRef>) => {
    const styles: Style[string][] = [];

    const processStyles = (context: ManifestContextAPI) => {
      styles.push(...Object.values(context.resolver.getStyleDefinitions()));
      context.getChildren().forEach((child) => processStyles(child));
    };

    processStyles(componentsAPI.getContext(editorPointer));

    return styles.some((style) => {
      return (
        style.cssPropertyType &&
        ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME[actionName]?.find(
          (item) => item === style.cssPropertyType,
        )
      );
    });
  };

export default createDefaultStyleActionValidator;
